// 상단 이미지 6개, form , 신청하기 , 푸터
// 질문 한페이지에 3개

import React, { useEffect, useState } from "react";
// import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { validateName, validatePhoneNumber } from "../utils/validation";
import { handleFormSubmit } from "../handlers/formHandlers";
import PhoneNumberInput from "../components/PhoneNumberInput";
import BenefitPeriod from "../components/BenefitPeriod";
import PrivacyPolicyAgree from "../components/PrivacyPolicyAgree";
import {
  options,
  options2,
  phoneFirstOptions,
  prohibitedWords,
} from "../utils/dummyData";

// import "./randingStyle10.scss";

import "./randingStyle1.scss";
import PrivacyContent from "./PrivacyContent";

function RandingStyle13({
  urlCode,
  urlCodeSettingId,
  img1Path,
  img2Path,
  img3Path,
  img4Path,
  img5Path,
  img6Path,
  img10Path,
  img11Path,
  step1Title,
  step2Title,
  step3Title,
  numberColor,
  keepBTN,
  step1Options,
  step2Options,
  qOptionColor,
  postBTN,
  companyName,
  callNumber,
  footerPath,
  // 랜딩 별로 태그 설정인 경우

  apiUrl,
  eventDates,
  treatments,
  adTarget,
  kakaotalk,
  carrotTag,
}) {
  const navigate = useNavigate();

  // 상태 관리
  const [name, setName] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false); // 버튼 상태 관리
  const [phoneNumber, setPhoneNumber] = useState({
    first: "",
    second: "",
    third: "",
  });
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [isAgreed, setIsAgreed] = useState(false);
  const [isPrivacyPolicyModal, setIsPrivacyPolicyModal] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);

  // 유효성 검사
  const validateInput = () => {
    return (
      validateName(name, prohibitedWords) && validatePhoneNumber(phoneNumber)
    );
  };

  // 이벤트 핸들러
  const handlePhoneNumberChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, "");

    setPhoneNumber((prev) => ({
      ...prev,
      [name]: numericValue,
    }));
  };

  const handleSelectImplant = (option) => {
    setSelectedOption(option);
  };

  const handleSelectEvent = (option) => {
    setSelectedValue(option);
  };

  const togglePrivacyPolicyModal = () => {
    setIsPrivacyPolicyModal(!isPrivacyPolicyModal);
  };

  const handleSubmit = () => {
    // selectedValue가 빈 값일 경우 treatments의 첫 번째 value로 설정
    let finalSelectedValue =
      selectedValue && selectedValue !== ""
        ? selectedValue
        : treatments && treatments.length > 0
        ? treatments[0].value
        : null; // treatments가 비어 있는 경우 null

    // finalSelectedValue가 객체인 경우 value 추출
    if (
      finalSelectedValue &&
      typeof finalSelectedValue === "object" &&
      finalSelectedValue.value
    ) {
      finalSelectedValue = finalSelectedValue.value;
    }

    if (treatments && !finalSelectedValue) {
      console.error("선택 가능한 값이 없습니다.");
      return; // treatments가 비어 있는 경우 처리
    }

    handleFormSubmit({
      name,
      phoneNumber,
      selectedOption,
      isAgreed,
      submitCount,
      setSubmitCount,
      validateInput,
      urlCode,
      urlCodeSettingId,
      navigate,
      setIsSubmitting,

      apiUrl,
      selectedValue: finalSelectedValue, // 업데이트된 selectedValue 전달
      kakaotalk,
      carrotTag,
    });
  };

  return (
    <div className="form-container">
      <div className="step2">
        {img1Path && (
          <a href={callNumber} style={{ display: "contents" }}>
            <img src={img1Path} alt="임플란트 고민중이세요?" />
          </a>
        )}
        {img2Path && <img src={img2Path} alt="임플란트 고민중이세요?" />}
        {img3Path && <img src={img3Path} alt="임플란트 고민중이세요?" />}
        {img4Path && <img src={img4Path} alt="임플란트 고민중이세요?" />}
        {img5Path && <img src={img5Path} alt="임플란트 고민중이세요?" />}
        {img6Path && <img src={img6Path} alt="임플란트 고민중이세요?" />}

        <div className="qBox">
          {step1Title ? (
            <div className="qTitle">
              <img src={step1Title} alt="임플란트 고민중이세요?" />
            </div>
          ) : (
            <div className="qTitleSmall">
              <span>01 </span>
              <p>신청하고 싶은 시술은?</p>
            </div>
          )}
          <div
            className="qOptions twobytwo"
            style={{ transform: " translateX(0%)" }}
          >
            {treatments.map((option, index) => (
              <img
                style={{ width: "32%", cursor: "pointer" }}
                key={index.value}
                src={`${step1Options}/${
                  selectedValue === option.value
                    ? `qoption${index + 1}(1)`
                    : `qoption${index + 1}`
                }.png`}
                alt={option.value}
                onClick={() => handleSelectEvent(option.value)}
              />
            ))}
          </div>
          {step2Title ? (
            <div className="qTitle">
              <img src={step2Title} alt="임플란트 고민중이세요?" />
            </div>
          ) : (
            <div className="qTitleSmall">
              <span>02 </span>
              <p>임플란트 필요한 개수는?</p>
            </div>
          )}
          <div
            className="qOptions twobytwo"
            style={{ transform: " translateX(0%)" }}
          >
            {options2.map((option, index) => (
              <img
                style={{ width: "32%", cursor: "pointer" }}
                key={index}
                src={`${step2Options}/${
                  selectedOption === option
                    ? `qoption${index + 1}(1)`
                    : `qoption${index + 1}`
                }.png`}
                alt={option}
                onClick={() => handleSelectImplant(option)}
              />
            ))}
          </div>
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          {step3Title ? (
            <div className="qTitle">
              <img src={step3Title} alt="임플란트 고민중이세요?" />
            </div>
          ) : (
            <div className="qTitleSmall">
              <span>03 </span>
              <p>귀하의 성함과 연락처를 입력해주세요</p>
            </div>
          )}
          <form
            className="formBox"
            onSubmit={(e) => {
              e.preventDefault(); // 기본 제출 동작 방지
              handleSubmit(); // 기존 handleSubmit 호출
            }}
          >
            <div className="formField">
              <label htmlFor="name">이름</label>
              <input
                type="text"
                id="name"
                maxLength="10"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <PhoneNumberInput
              phoneNumber={phoneNumber}
              phoneFirstOptions={phoneFirstOptions}
              handlePhoneNumberChange={handlePhoneNumberChange}
            />
            <PrivacyPolicyAgree
              isAgreed={isAgreed}
              setIsAgreed={setIsAgreed}
              togglePrivacyPolicyModal={togglePrivacyPolicyModal}
            />
            {eventDates && <BenefitPeriod />}
            {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
            {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
            <p className="benefitInfo">
              이벤트 대상자 : {adTarget || "해당 매체 이용자"}
            </p>
            {isPrivacyPolicyModal && (
              <div className="modalOverlay" onClick={togglePrivacyPolicyModal}>
                <div
                  className="privacyPolicyContent"
                  onClick={(e) => e.stopPropagation()}
                >
                  <PrivacyContent companyName={companyName} />
                </div>
              </div>
            )}
            <button
              type="submit"
              className="sendBtnBox"
              disabled={isSubmitting}
            >
              <img src={postBTN} alt="신청하기" />
            </button>
          </form>
        </div>

        {img10Path && <img src={img10Path} alt="임플란트 고민중이세요?" />}
        {img11Path && <img src={img11Path} alt="임플란트 고민중이세요?" />}
      </div>

      <div className="footer">
        {footerPath && <img src={footerPath} alt="푸터" />}{" "}
      </div>
    </div>
  );
}

export default RandingStyle13;
